import { Divider, formatBytes } from "@vindral/components"
import { Statistic } from "../../molecules/Statistic"
import { trpc } from "../../trpc"
import { isDefined } from "../../utils/is-defined"
import { AnalyticsQueryArgs } from "./Analytics"

const UsageStatistics = (props: AnalyticsQueryArgs) => {
  const { time } = props
  const lookback = time.to - time.from
  const getChange = (first: number | undefined, second: number | undefined) => {
    if (typeof first === "undefined" || typeof second === "undefined") {
      return undefined
    }
    return first / second - 1
  }

  const { data: hlsEgressBytes } = trpc.analytics.hlsEgressBytes.useQuery(
    {
      ...props,
      time: time.to,
      lookback,
    },
    { keepPreviousData: true }
  )
  const { data: previousHlsEgressBytes } = trpc.analytics.hlsEgressBytes.useQuery(
    {
      ...props,
      time: time.from,
      lookback,
    },
    { keepPreviousData: true }
  )

  const { data: clippingBytes } = trpc.analytics.clippingBytes.useQuery(
    {
      ...props,
      time: time.to,
      lookback,
    },
    { keepPreviousData: true }
  )
  const { data: previousClippingBytes } = trpc.analytics.clippingBytes.useQuery(
    {
      ...props,
      time: time.from,
      lookback,
    },
    { keepPreviousData: true }
  )

  const { data: rtmpEgressBytes } = trpc.analytics.rtmpEgressBytes.useQuery(
    {
      ...props,
      time: time.to,
      lookback,
    },
    { keepPreviousData: true }
  )
  const { data: previousRtmpEgressBytes } = trpc.analytics.rtmpEgressBytes.useQuery(
    {
      ...props,
      time: time.from,
      lookback,
    },
    { keepPreviousData: true }
  )

  const { data: restreamBytes } = trpc.analytics.restreamBytes.useQuery(
    {
      ...props,
      time: time.to,
      lookback,
    },
    { keepPreviousData: true }
  )
  const { data: previousRestreamBytes } = trpc.analytics.restreamBytes.useQuery(
    {
      ...props,
      time: time.from,
      lookback,
    },
    { keepPreviousData: true }
  )

  return (
    <div className="my-4 mb-12 flex flex-col gap-4 xl:flex-row">
      <div className="flex gap-4 xl:w-1/2">
        <div className="w-1/2 transition-colors">
          <Statistic
            value={isDefined(hlsEgressBytes) ? formatBytes(hlsEgressBytes) : formatBytes(0)}
            title="HLS EGRESS"
            subtext="Total HLS egress bytes"
            info="Total amount of HLS egress bytes over the selected time period"
            tooltip="Trend comparing selected time period to earlier adjacent period of same length"
            change={getChange(hlsEgressBytes, previousHlsEgressBytes)}
          />
        </div>
        <Divider variant="vertical" />
        <div className="w-1/2 transition-colors">
          <Statistic
            value={isDefined(clippingBytes) ? formatBytes(clippingBytes) : formatBytes(0)}
            title="Clipping"
            subtext="Total clipping bytes"
            info="Total amount of clipping bytes over the selected time period"
            tooltip="Trend comparing selected time period to earlier adjacent period of same length"
            change={getChange(clippingBytes, previousClippingBytes)}
          />
        </div>
      </div>
      <div className="flex gap-4 xl:w-1/2">
        <Divider variant="vertical" />
        <div className="w-1/2 transition-colors">
          <Statistic
            value={isDefined(rtmpEgressBytes) ? formatBytes(rtmpEgressBytes) : formatBytes(0)}
            title="RTMP EGRESS"
            subtext="Total RTMP egress bytes"
            info="Total amount of RTMP egress bytes over the selected time period"
            tooltip="Trend comparing selected time period to earlier adjacent period of same length"
            change={getChange(rtmpEgressBytes, previousRtmpEgressBytes)}
          />
        </div>
        <Divider variant="vertical" />
        <div className="w-1/2 transition-colors">
          <Statistic
            value={isDefined(restreamBytes) ? formatBytes(restreamBytes) : formatBytes(0)}
            title="Restream"
            subtext="Total restream bytes"
            info="Total amount of restream bytes over the selected time period"
            tooltip="Trend comparing selected time period to earlier adjacent period of same length"
            change={getChange(restreamBytes, previousRestreamBytes)}
          />
        </div>
      </div>
    </div>
  )
}

export const Usage = (props: AnalyticsQueryArgs) => {
  return <UsageStatistics {...props} />
}
